module.exports = __webpack_public_path__ + "img/FilterHelp.28a2735e.png";